import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { ProfileCompletionForm } from '../../components/ProfileCompletionModal';
import { useLoginService } from '../../services/loginService/index';
import rootStyles from '../Login/index.module.scss';
import formStyles from '../Login/LoginContent/index.module.scss';

function ProfileStepChallenge() {
  const {
    state: { profileStepOnComplete },
  } = useLoginService();

  return (
    <div className={classNames(formStyles.root, rootStyles.boxContainer, 'w-full')}>
      <span className={rootStyles.title}>Complete your profile</span>
      <ProfileCompletionForm
        screen="profile_step_challenge"
        showSuccessToast={false}
        onComplete={() => profileStepOnComplete?.()}
      />
    </div>
  );
}

export default observer(ProfileStepChallenge);
